<template>
  <section>
    <h2 class="sub-title">
      {{ UserSearch.searchRunner[lang] }}
    </h2>
    <form
      action=""
      @submit="runner"
      method="get"
      id="js-form"
      class="search-form"
    >
      <input
        type="hidden"
        name="event"
        v-bind:value="this.$route.query.event"
      />
      <input type="hidden" name="page" value="1" />
      <label>
        <input
          v-model="modelUserSearch"
          class="search-box"
          :class="{ alert: isSearchAlert }"
          type="text"
          :placeholder="UserSearch.placeholder[lang]"
          autocomplete="on"
          required
        />
      </label>
      <button type="submit" class="button flex-all-center">
        <span>
          {{ UserSearch.search[lang] }}
        </span>
      </button>
    </form>
  </section>
</template>

<script>
import UserSearch from "../../../assets/constants/ranking/userSearch";
export default {
  data() {
    return {
      UserSearch: UserSearch,
      isSearchAlert: false,
      modelUserSearch: null,
    };
  },
  methods: {
    runner: function () {
      sessionStorage.setItem("runnerName", this.modelUserSearch);
      document.getElementById("js-form").action = `/${this.langPath}${
        this.$route.path.includes("company") ? "company/" : ""
      }ranking/runner`;
    },
  },
  watch: {
    modelUserSearch: function () {
      this.isSearchAlert = false;
    },
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "UserSearch",
};
</script>

<style scoped>
.sub-title {
  font-size: 32px;
  font-weight: 900;
}
.search-form {
  display: flex;
  align-items: center;
  margin: 23px 0 0 0;
  padding: 40px;
  background-color: #eee;
  .search-box {
    width: 421px;
    height: 60px;
    margin: 0 15px 0 0;
    padding: 0 0 0 30px;
    border: 1px solid #fff;
    font-size: 16px;
    background-color: #fff;
    &::placeholder {
      color: #9b9b9b;
    }
  }
  .button {
    width: 120px;
    height: 60px;
    border: solid 1px #000;
    font-size: 20px;
    color: #000;
    background-color: #fff;
    &::before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 4px 0 0;
      background: url("../../../assets/images/mushimegane.svg") no-repeat center /
        18px;
    }
    &:hover {
      color: #fff;
      background-color: #000;
      &::before {
        background: url("../../../assets/images/mushimegane-hover.svg")
          no-repeat center / 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ranking/UserSearch.vue